export default {
  currencies: state => state.currencies ? Object.keys(state.currencies).map(code => ({ code, symbol: state.currencies[code] })) : []
}
